import React from 'react';
import { IAttendanceCalendarEventProps } from "../../attendance.types";


const AttendanceCalendarEvent = ({ event }: IAttendanceCalendarEventProps) => {
    return (
        <div className={`employee-attendance__attendance-tag ${event.attendance.status.toLowerCase()}`} />
    );
};

export default AttendanceCalendarEvent;
